import React, { useEffect,useState } from 'react';
import { Modal } from "react-bootstrap";
import moment from 'moment';
import { KeyboardDatePicker } from '@material-ui/pickers';
import startOfWeek from "date-fns/startOfWeek";
import isSameDay from "date-fns/isSameDay";
import endOfWeek from "date-fns/endOfWeek";
import isWithinInterval from "date-fns/isWithinInterval";
import { IconButton, withStyles } from "@material-ui/core";
import format from "date-fns/format";
import { createStyles } from "@material-ui/styles";
import clsx from "clsx";
import isValid from "date-fns/isValid";
export const DateAndWeekModal = ({ show, handleClose, handleDateChange, classes }: any) => {
    const [week, setWeek]: any = useState(null);
    const [date, setDate]: any = useState(null);
    
    const handleChangeDate = (date: any) => {
        setDate(date);
    }

    const handleChangeWeek = (date: any) => {
        let weekStartDate: any = startOfWeek(new Date(date));
        setWeek(weekStartDate);
    }
    const makeJSDateObject = (date: any) => {
        if (date) return new Date(date);
        return null;
    }
    const renderWrappedWeekDay = (date: any, selectedDate: any, dayInCurrentMonth: any) => {
        if (date) {
            let dateClone: any = makeJSDateObject(date);
            let selectedDateClone: any = makeJSDateObject(selectedDate);

            const start = startOfWeek(selectedDateClone);
            const end = endOfWeek(selectedDateClone);

            const dayIsBetween = isWithinInterval(dateClone, { start, end });
            const isFirstDay = isSameDay(dateClone, start);
            const isLastDay = isSameDay(dateClone, end);
            const wrapperClassName = clsx({
                [classes.highlight]: dayIsBetween,
                [classes.firstHighlight]: isFirstDay,
                [classes.endHighlight]: isLastDay,
            });

            const dayClassName = clsx(classes.day, {
                [classes.nonCurrentMonthDay]: !dayInCurrentMonth,
                [classes.highlightNonCurrentMonthDay]: !dayInCurrentMonth && dayIsBetween,
            });

            return (
                <div className={wrapperClassName}>
                    <IconButton className={dayClassName}>
                        <span> {format(dateClone, "d")} </span>
                    </IconButton>
                </div>
            );
        } else {
            return (<div></div>)
        }
    };
    const formatWeekSelectLabel = (date: any, invalidLabel: any) => {
        let dateClone = makeJSDateObject(date);
        return dateClone && isValid(dateClone)
            ? moment(dateClone).format('YYYY/MM/DD')
            : invalidLabel;
    };
    const handleSave = () => {
        let sDate: any, eDate: any;
        if (week) {
            console.log('inWeek');
            
            sDate = moment(week).format('YYYY-MM-DD');
            eDate = moment(week).add(6, 'days').format('YYYY-MM-DD')
        } else if (date) {
            console.log('indate');
            
            sDate = moment(date).format('YYYY-MM-DD');
            eDate = moment(date).format('YYYY-MM-DD');
        }
        setDate(null);
        setWeek(null);
        handleDateChange(sDate, eDate);
    }
    return (
        <Modal
            show={show}
            onHide={handleClose}
            className="newcommon close-chat"
            centered
        >
            <Modal.Header>
                <div className="modal-title">Date</div>
                <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => { handleClose() }}
                ></button>
            </Modal.Header>

            <Modal.Body>
                <div className='d-flex flex-row m-2'>
                    <KeyboardDatePicker
                        className='m-2'
                        margin="none"
                        // id={"date-picker-dialog-day"}
                        // name={"date-picker-dialog-day"}
                        // label="Date"
                        placeholder='Date'
                        format="YYYY/MM/DD"
                        minDate={moment().subtract(6,'months')}
                        // maxDate={new Date()}
                        value={date}
                        onChange={handleChangeDate}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                    <KeyboardDatePicker
                        className='m-2'
                        margin="none"
                        // id={"date-picker-dialog-week"}
                        // name={"date-picker-dialog-week"}
                        // label="Week"
                        placeholder='Week'
                        format="YYYY/MM/DD"
                        minDate={moment().subtract(6,'months')}
                        // maxDate={new Date()}
                        value={week}
                        onChange={handleChangeWeek}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        renderDay={renderWrappedWeekDay}
                        labelFunc={formatWeekSelectLabel}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button
                    disabled={!date && !week }
                    className="btn btn-primary"
                    onClick={() => {
                        handleSave();
                    }}
                >
                    Save
                </button>
            </Modal.Footer>
        </Modal>
    );
};
const styles = createStyles((theme:any) => ({
  dayWrapper: {
    position: "relative",
  },
  day: {
    width: 36,
    height: 36,
    fontSize: theme.typography.caption.fontSize,
    margin: "0 2px",
    color: "inherit",
  },
  customDayHighlight: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: "2px",
    right: "2px",
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: "50%",
  },
  nonCurrentMonthDay: {
    color: theme.palette.text.disabled,
  },
  highlightNonCurrentMonthDay: {
    color: "#676767",
  },
  highlight: {
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  firstHighlight: {
    extend: "highlight",
    borderTopLeftRadius: "50%",
    borderBottomLeftRadius: "50%",
  },
  endHighlight: {
    extend: "highlight",
    borderTopRightRadius: "50%",
    borderBottomRightRadius: "50%",
  },
}));
export default withStyles(styles)(DateAndWeekModal);